import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { SessionClient } from "../../parentApi";

const client = new SessionClient(app_uri, axiosClient());

export default client;
